"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Checks if value is a string
 *
 * @Param {any} str = The value to check.
 *
 * @Example
 *
 *   isString('')
 *   //=> true
 *
 *   isString(null)
 *   //=> false
 *
 *   isString(undefined)
 *   //=> false
 *
 *   isString({})
 *   //=> false
 *
 *   isString([])
 *   //=> false
 */
function isString(value) {
    return typeof value === 'string' || value instanceof String;
}
exports.isString = isString;
//# sourceMappingURL=is-string.js.map